// 后端地址由环境变量 VUE_APP_API_BASE 控制(见 .env.development / .env.production)
// 留空时表示同源部署,请求走相对路径 /api/...,由 devServer 代理或 Nginx 反向代理转发
const API_BASE = process.env.VUE_APP_API_BASE || ''

export async function request(path, token, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Token': token,
      ...(options.headers || {})
    }
  })
  const result = await response.json()
  if (result.code !== 0) throw new Error(result.message || '请求失败')
  return result.data
}
